<template>
  <div class="parameter-checkbox">
    <app-radio-button
      v-for="option in booleanParameterOptions"
      :key="String(option.value)"
      v-model="theModel"
      :radio-value="option.value"
      :name="radioName"
      :text="option.label"
      :disabled="!editable"
    />
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import {
  ParameterInstance,
} from "../../../models/interfaces/parameters/parameter-models";
import AppRadioButton from "../../ui-kit/radio-button/AppRadioButton.vue";

let boolRadioSeq = 0;

/**
 * A component for displaying BoolValue type
 */

@Component({
  name: "ParameterCheckbox",
  components: { AppRadioButton },
  emits: ["update:modelValue", "update:nested"]
})
export default class ParameterCheckbox extends Vue {
  @Prop({ default: {} as ParameterInstance })
  modelValue!: ParameterInstance;
  @Prop({ type: Boolean, default: false }) editable!: boolean;
  @Prop({ default: undefined }) nestedIndex!: number | undefined;

  // Имя группы своё у каждого поля: у нативного radio имя общее на весь документ
  radioName = `param-bool-${++boolRadioSeq}`;

  get booleanParameterOptions() {
    return [
      {
        label: this.$t("yes"),
        value: true,
      },
      {
        label: this.$t("no"),
        value: false,
      },
      {
        label: this.$t("not_selected"),
        value: null,
      },
    ];
  }

  get theModel(): boolean | null {
    return this.modelValue.BoolValue === undefined ? null : this.modelValue.BoolValue
  }

  set theModel(newValue: boolean | null) {
    this.modelValue.BoolValue = newValue;
    this.$emit('update:modelValue', this.modelValue)
    // тот же конвейер, что у вложенного ParameterInline: поднимаем событие до root.
    // eventKind=2: изменение значения (не переписывает StringValue/SelectedValue).
    // Свежее значение кладём в sectionText, чтобы root взял его как источник правды.
    this.$emit('update:nested', {
      fieldKey: null,
      sectionText: newValue === true ? 'true' : newValue === false ? 'false' : '',
      eventKind: 2,
      nestedIndex: this.nestedIndex,
      opts: {
        InstanceId: this.modelValue.Id,
        ValueType: this.modelValue.ValueType,
        ValueSet: this.modelValue.ValueSet,
        TemplateId: this.modelValue.TemplateId,
        selectedId: this.modelValue.SelectedValue?.Id,
      },
    })
  }
}
</script>
<style scoped lang="scss">
.parameter-checkbox {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
</style>
